/**
 * Generated by orval 🍺
 * Do not edit manually.
 * API WANGRE
 * API REST de WANGRE, plateforme de gestion de l'Association Monde Rural. JSON snake_case ; erreurs `{ message, code, details | errors }` en français ; montants en chaîne décimale + `currency` ; mises à jour avec `If-Match: <version>` ; créations hors ligne avec `Idempotency-Key`.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuthenticationExceptionResponse,
  AuthorizationExceptionResponse,
  ChangePasswordRequest,
  UpdatePreferencesRequest,
  UpdateProfileRequest,
  V1MeActivity200,
  V1MeActivityParams,
  V1MePhoneVerification200,
  V1MePhoneVerify200,
  V1MePreferencesShow200,
  V1MePreferencesUpdate200,
  V1MeSessionsIndex200,
  V1MeShow200,
  V1MeUpdate200,
  ValidationExceptionResponse,
  VerifyPhoneRequest
} from '../../model';

import { apiFetch } from '../../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getV1MeShowUrl = () => {




  return `/v1/me`
}

/**
 * @summary Utilisateur connecté, rôles, permissions effectives (avec leur portée) et affectations
 */
export const v1MeShow = async ( options?: Parameters<typeof apiFetch>[1]): Promise<V1MeShow200> => {

  return apiFetch<V1MeShow200>(getV1MeShowUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1MeShowQueryKey = () => {
    return [
    `/v1/me`
    ] as const;
    }


export const getV1MeShowQueryOptions = <TData = Awaited<ReturnType<typeof v1MeShow>>, TError = AuthenticationExceptionResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeShow>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MeShowQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MeShow>>> = ({ signal }) => v1MeShow({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MeShow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1MeShowQueryResult = NonNullable<Awaited<ReturnType<typeof v1MeShow>>>
export type V1MeShowQueryError = AuthenticationExceptionResponse


export function useV1MeShow<TData = Awaited<ReturnType<typeof v1MeShow>>, TError = AuthenticationExceptionResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeShow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MeShow>>,
          TError,
          Awaited<ReturnType<typeof v1MeShow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MeShow<TData = Awaited<ReturnType<typeof v1MeShow>>, TError = AuthenticationExceptionResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeShow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MeShow>>,
          TError,
          Awaited<ReturnType<typeof v1MeShow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MeShow<TData = Awaited<ReturnType<typeof v1MeShow>>, TError = AuthenticationExceptionResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeShow>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Utilisateur connecté, rôles, permissions effectives (avec leur portée) et affectations
 */

export function useV1MeShow<TData = Awaited<ReturnType<typeof v1MeShow>>, TError = AuthenticationExceptionResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeShow>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1MeShowQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getV1MeUpdateUrl = () => {




  return `/v1/me`
}

/**
 * @summary Modifier son profil : photo, téléphone, WhatsApp (ACC-07). En-tête `If-Match` obligatoire
 */
export const v1MeUpdate = async (updateProfileRequest?: UpdateProfileRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1MeUpdate200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1MeUpdate200>(getV1MeUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateProfileRequest)
  }
);}





export const getV1MeUpdateMutationKey = () => ['v1MeUpdate'] as const;

export const getV1MeUpdateMutationOptions = <TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse | ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MeUpdate>>, TError,V1MeUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MeUpdate>>, TError,V1MeUpdateMutationVariables, TContext> => {

const mutationKey = getV1MeUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MeUpdate>>, V1MeUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1MeUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MeUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MeUpdate>>>
    export type V1MeUpdateMutationBody = UpdateProfileRequest | undefined
    export type V1MeUpdateMutationError = AuthenticationExceptionResponse | AuthorizationExceptionResponse | ValidationExceptionResponse
    export type V1MeUpdateMutationVariables = {data?: UpdateProfileRequest}

    /**
 * @summary Modifier son profil : photo, téléphone, WhatsApp (ACC-07). En-tête `If-Match` obligatoire
 */
export const useV1MeUpdate = <TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse | ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MeUpdate>>, TError,V1MeUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MeUpdate>>,
        TError,
        V1MeUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getV1MeUpdateMutationOptions(options), queryClient);
    }
    export const getV1MePasswordUpdateUrl = () => {




  return `/v1/me/password`
}

/**
 * @summary Changer son mot de passe (ACC-06) : les autres appareils sont déconnectés
 */
export const v1MePasswordUpdate = async (changePasswordRequest: ChangePasswordRequest, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<void>(getV1MePasswordUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(changePasswordRequest)
  }
);}





export const getV1MePasswordUpdateMutationKey = () => ['v1MePasswordUpdate'] as const;

export const getV1MePasswordUpdateMutationOptions = <TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse | ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MePasswordUpdate>>, TError,V1MePasswordUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MePasswordUpdate>>, TError,V1MePasswordUpdateMutationVariables, TContext> => {

const mutationKey = getV1MePasswordUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MePasswordUpdate>>, V1MePasswordUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1MePasswordUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MePasswordUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MePasswordUpdate>>>
    export type V1MePasswordUpdateMutationBody = ChangePasswordRequest
    export type V1MePasswordUpdateMutationError = AuthenticationExceptionResponse | AuthorizationExceptionResponse | ValidationExceptionResponse
    export type V1MePasswordUpdateMutationVariables = {data: ChangePasswordRequest}

    /**
 * @summary Changer son mot de passe (ACC-06) : les autres appareils sont déconnectés
 */
export const useV1MePasswordUpdate = <TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse | ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MePasswordUpdate>>, TError,V1MePasswordUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MePasswordUpdate>>,
        TError,
        V1MePasswordUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getV1MePasswordUpdateMutationOptions(options), queryClient);
    }
    export const getV1MePhoneVerificationUrl = () => {




  return `/v1/me/phone/verification`
}

/**
 * @summary Vérifier son numéro (lot F17c, INT-05) : code envoyé par SMS au numéro du profil (jamais renvoyé par l'API)
 */
export const v1MePhoneVerification = async ( options?: Parameters<typeof apiFetch>[1]): Promise<V1MePhoneVerification200> => {

  return apiFetch<V1MePhoneVerification200>(getV1MePhoneVerificationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getV1MePhoneVerificationMutationKey = () => ['v1MePhoneVerification'] as const;

export const getV1MePhoneVerificationMutationOptions = <TError = AuthenticationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MePhoneVerification>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MePhoneVerification>>, TError,void, TContext> => {

const mutationKey = getV1MePhoneVerificationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MePhoneVerification>>, void> = () => {


          return  v1MePhoneVerification(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MePhoneVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof v1MePhoneVerification>>>

    export type V1MePhoneVerificationMutationError = AuthenticationExceptionResponse


    /**
 * @summary Vérifier son numéro (lot F17c, INT-05) : code envoyé par SMS au numéro du profil (jamais renvoyé par l'API)
 */
export const useV1MePhoneVerification = <TError = AuthenticationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MePhoneVerification>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MePhoneVerification>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getV1MePhoneVerificationMutationOptions(options), queryClient);
    }
    export const getV1MePhoneVerifyUrl = () => {




  return `/v1/me/phone/verify`
}

/**
 * @summary Valider le numéro avec le code reçu par SMS : codes et alertes par SMS possibles
 */
export const v1MePhoneVerify = async (verifyPhoneRequest: VerifyPhoneRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1MePhoneVerify200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1MePhoneVerify200>(getV1MePhoneVerifyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(verifyPhoneRequest)
  }
);}





export const getV1MePhoneVerifyMutationKey = () => ['v1MePhoneVerify'] as const;

export const getV1MePhoneVerifyMutationOptions = <TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse | ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MePhoneVerify>>, TError,V1MePhoneVerifyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MePhoneVerify>>, TError,V1MePhoneVerifyMutationVariables, TContext> => {

const mutationKey = getV1MePhoneVerifyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MePhoneVerify>>, V1MePhoneVerifyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1MePhoneVerify(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MePhoneVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof v1MePhoneVerify>>>
    export type V1MePhoneVerifyMutationBody = VerifyPhoneRequest
    export type V1MePhoneVerifyMutationError = AuthenticationExceptionResponse | AuthorizationExceptionResponse | ValidationExceptionResponse
    export type V1MePhoneVerifyMutationVariables = {data: VerifyPhoneRequest}

    /**
 * @summary Valider le numéro avec le code reçu par SMS : codes et alertes par SMS possibles
 */
export const useV1MePhoneVerify = <TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse | ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MePhoneVerify>>, TError,V1MePhoneVerifyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MePhoneVerify>>,
        TError,
        V1MePhoneVerifyMutationVariables,
        TContext
      > => {
      return useMutation(getV1MePhoneVerifyMutationOptions(options), queryClient);
    }
    export const getV1MeSessionsIndexUrl = () => {




  return `/v1/me/sessions`
}

/**
 * @summary Sessions actives : appareils mobiles et navigateurs (SYS-P03)
 */
export const v1MeSessionsIndex = async ( options?: Parameters<typeof apiFetch>[1]): Promise<V1MeSessionsIndex200> => {

  return apiFetch<V1MeSessionsIndex200>(getV1MeSessionsIndexUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1MeSessionsIndexQueryKey = () => {
    return [
    `/v1/me/sessions`
    ] as const;
    }


export const getV1MeSessionsIndexQueryOptions = <TData = Awaited<ReturnType<typeof v1MeSessionsIndex>>, TError = AuthenticationExceptionResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeSessionsIndex>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MeSessionsIndexQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MeSessionsIndex>>> = ({ signal }) => v1MeSessionsIndex({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MeSessionsIndex>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1MeSessionsIndexQueryResult = NonNullable<Awaited<ReturnType<typeof v1MeSessionsIndex>>>
export type V1MeSessionsIndexQueryError = AuthenticationExceptionResponse


export function useV1MeSessionsIndex<TData = Awaited<ReturnType<typeof v1MeSessionsIndex>>, TError = AuthenticationExceptionResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeSessionsIndex>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MeSessionsIndex>>,
          TError,
          Awaited<ReturnType<typeof v1MeSessionsIndex>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MeSessionsIndex<TData = Awaited<ReturnType<typeof v1MeSessionsIndex>>, TError = AuthenticationExceptionResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeSessionsIndex>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MeSessionsIndex>>,
          TError,
          Awaited<ReturnType<typeof v1MeSessionsIndex>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MeSessionsIndex<TData = Awaited<ReturnType<typeof v1MeSessionsIndex>>, TError = AuthenticationExceptionResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeSessionsIndex>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sessions actives : appareils mobiles et navigateurs (SYS-P03)
 */

export function useV1MeSessionsIndex<TData = Awaited<ReturnType<typeof v1MeSessionsIndex>>, TError = AuthenticationExceptionResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeSessionsIndex>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1MeSessionsIndexQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getV1MeSessionsDestroyUrl = (session: string,) => {




  return `/v1/me/sessions/${session}`
}

/**
 * @summary Déconnecter une session ou un appareil (SYS-P03 « Déconnecter »)
 */
export const v1MeSessionsDestroy = async (session: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getV1MeSessionsDestroyUrl(session),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getV1MeSessionsDestroyMutationKey = () => ['v1MeSessionsDestroy'] as const;

export const getV1MeSessionsDestroyMutationOptions = <TError = AuthenticationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MeSessionsDestroy>>, TError,V1MeSessionsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MeSessionsDestroy>>, TError,V1MeSessionsDestroyMutationVariables, TContext> => {

const mutationKey = getV1MeSessionsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MeSessionsDestroy>>, V1MeSessionsDestroyMutationVariables> = (props) => {
          const {session} = props ?? {};

          return  v1MeSessionsDestroy(session,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MeSessionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof v1MeSessionsDestroy>>>

    export type V1MeSessionsDestroyMutationError = AuthenticationExceptionResponse
    export type V1MeSessionsDestroyMutationVariables = {session: string}

    /**
 * @summary Déconnecter une session ou un appareil (SYS-P03 « Déconnecter »)
 */
export const useV1MeSessionsDestroy = <TError = AuthenticationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MeSessionsDestroy>>, TError,V1MeSessionsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MeSessionsDestroy>>,
        TError,
        V1MeSessionsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getV1MeSessionsDestroyMutationOptions(options), queryClient);
    }
    export const getV1MeActivityUrl = (params?: V1MeActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/me/activity?${stringifiedParams}` : `/v1/me/activity`
}

/**
 * @summary Mon activité : historique de ses propres actions (AUD-03). `filter[action]`, `filter[from]`, `filter[to]`
 */
export const v1MeActivity = async (params?: V1MeActivityParams, options?: Parameters<typeof apiFetch>[1]): Promise<V1MeActivity200> => {

  return apiFetch<V1MeActivity200>(getV1MeActivityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1MeActivityQueryKey = (params?: V1MeActivityParams,) => {
    return [
    `/v1/me/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getV1MeActivityQueryOptions = <TData = Awaited<ReturnType<typeof v1MeActivity>>, TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse>(params?: V1MeActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeActivity>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MeActivityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MeActivity>>> = ({ signal }) => v1MeActivity(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MeActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1MeActivityQueryResult = NonNullable<Awaited<ReturnType<typeof v1MeActivity>>>
export type V1MeActivityQueryError = AuthenticationExceptionResponse | AuthorizationExceptionResponse


export function useV1MeActivity<TData = Awaited<ReturnType<typeof v1MeActivity>>, TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse>(
 params: undefined |  V1MeActivityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MeActivity>>,
          TError,
          Awaited<ReturnType<typeof v1MeActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MeActivity<TData = Awaited<ReturnType<typeof v1MeActivity>>, TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse>(
 params?: V1MeActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MeActivity>>,
          TError,
          Awaited<ReturnType<typeof v1MeActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MeActivity<TData = Awaited<ReturnType<typeof v1MeActivity>>, TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse>(
 params?: V1MeActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeActivity>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mon activité : historique de ses propres actions (AUD-03). `filter[action]`, `filter[from]`, `filter[to]`
 */

export function useV1MeActivity<TData = Awaited<ReturnType<typeof v1MeActivity>>, TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse>(
 params?: V1MeActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MeActivity>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1MeActivityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getV1MePreferencesShowUrl = () => {




  return `/v1/me/preferences`
}

/**
 * @summary Préférences d'affichage (SYS-P04)
 */
export const v1MePreferencesShow = async ( options?: Parameters<typeof apiFetch>[1]): Promise<V1MePreferencesShow200> => {

  return apiFetch<V1MePreferencesShow200>(getV1MePreferencesShowUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getV1MePreferencesShowQueryKey = () => {
    return [
    `/v1/me/preferences`
    ] as const;
    }


export const getV1MePreferencesShowQueryOptions = <TData = Awaited<ReturnType<typeof v1MePreferencesShow>>, TError = AuthenticationExceptionResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MePreferencesShow>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getV1MePreferencesShowQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof v1MePreferencesShow>>> = ({ signal }) => v1MePreferencesShow({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof v1MePreferencesShow>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type V1MePreferencesShowQueryResult = NonNullable<Awaited<ReturnType<typeof v1MePreferencesShow>>>
export type V1MePreferencesShowQueryError = AuthenticationExceptionResponse


export function useV1MePreferencesShow<TData = Awaited<ReturnType<typeof v1MePreferencesShow>>, TError = AuthenticationExceptionResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MePreferencesShow>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MePreferencesShow>>,
          TError,
          Awaited<ReturnType<typeof v1MePreferencesShow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MePreferencesShow<TData = Awaited<ReturnType<typeof v1MePreferencesShow>>, TError = AuthenticationExceptionResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MePreferencesShow>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof v1MePreferencesShow>>,
          TError,
          Awaited<ReturnType<typeof v1MePreferencesShow>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useV1MePreferencesShow<TData = Awaited<ReturnType<typeof v1MePreferencesShow>>, TError = AuthenticationExceptionResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MePreferencesShow>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Préférences d'affichage (SYS-P04)
 */

export function useV1MePreferencesShow<TData = Awaited<ReturnType<typeof v1MePreferencesShow>>, TError = AuthenticationExceptionResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof v1MePreferencesShow>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getV1MePreferencesShowQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getV1MePreferencesUpdateUrl = () => {




  return `/v1/me/preferences`
}

/**
 * @summary Enregistrer ses préférences (SYS-P04, TRV-09)
 */
export const v1MePreferencesUpdate = async (updatePreferencesRequest?: UpdatePreferencesRequest, options?: Parameters<typeof apiFetch>[1]): Promise<V1MePreferencesUpdate200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<V1MePreferencesUpdate200>(getV1MePreferencesUpdateUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePreferencesRequest)
  }
);}





export const getV1MePreferencesUpdateMutationKey = () => ['v1MePreferencesUpdate'] as const;

export const getV1MePreferencesUpdateMutationOptions = <TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse | ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MePreferencesUpdate>>, TError,V1MePreferencesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof v1MePreferencesUpdate>>, TError,V1MePreferencesUpdateMutationVariables, TContext> => {

const mutationKey = getV1MePreferencesUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof v1MePreferencesUpdate>>, V1MePreferencesUpdateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  v1MePreferencesUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type V1MePreferencesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof v1MePreferencesUpdate>>>
    export type V1MePreferencesUpdateMutationBody = UpdatePreferencesRequest | undefined
    export type V1MePreferencesUpdateMutationError = AuthenticationExceptionResponse | AuthorizationExceptionResponse | ValidationExceptionResponse
    export type V1MePreferencesUpdateMutationVariables = {data?: UpdatePreferencesRequest}

    /**
 * @summary Enregistrer ses préférences (SYS-P04, TRV-09)
 */
export const useV1MePreferencesUpdate = <TError = AuthenticationExceptionResponse | AuthorizationExceptionResponse | ValidationExceptionResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof v1MePreferencesUpdate>>, TError,V1MePreferencesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof v1MePreferencesUpdate>>,
        TError,
        V1MePreferencesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getV1MePreferencesUpdateMutationOptions(options), queryClient);
    }
